import React, { Component } from "react";
import { Link } from "react-router-dom";

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'
import { Menu, MenuItem, ProSidebar, SubMenu } from "react-pro-sidebar";
import { map } from "jquery";
import { ADMIN_CMA_IDS } from "../cosntants";

const mapStateToProps = state => ({
    profileName: state.profileName,
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
}

class SioAndPressSidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isActive: false,
            isActiveHub: false,
            users: [
                { routeName: 'User Management', linkTo: '/admin-dashboard' },
            ],
            usersAdmin: [
                { routeName: 'User Management', linkTo: '/admin-dashboard' },
                { routeName: "All Users", linkTo: "/user-management" },
            ],
            usersActivity: [
                { routeName: 'User Management', linkTo: '/admin-dashboard' },
            ],
            usersActivityAll: [
                { routeName: 'User Management', linkTo: '/admin-dashboard' },
                { routeName: "All Users", linkTo: "/user-management" },
            ],
            communityHub: [
                { routeName: "Village Home Page", linkTo: "/villege-home-page" },
                { routeName: "MS Partners", linkTo: "/partners-view" },
                { routeName: 'MS Partner Home Page', linkTo: '/ms-partner-page' },
                { routeName: "Community Hub", linkTo: "/satellites-view" },
                { routeName: 'Community Hub Home Page', linkTo: '/satellite-page' },
            ],
            communityHubReference: [{ routeName: 'Interests', linkTo: '/Community-Interests' }],

            referenceValues: [
                { routeName: "Category", linkTo: "/filmcategory" },
                { routeName: "Award Category", linkTo: "/awardcategory" },
                { routeName: "Genre & Type", linkTo: "/filmgenre" },
                { routeName: "Interest Tracks", linkTo: "/filminterest" },
                { routeName: "Accessibility", linkTo: "/filmaccessibillity" },
                { routeName: "Credit Label", linkTo: "/filmcreditlebel" },
                { routeName: "Screening Types", linkTo: "/screeningtype" },
            ],
            fpgRouter: [
                { routeName: "Catalog", linkTo: "/filmlist" },
                { routeName: "Shorts Program", linkTo: "/short-program-list" },
            ],
            productscoupons: [
                { routeName: "Products", linkTo: "/product-list" },
                { routeName: "Discounts", linkTo: "/discounts-list" },
            ],
            festivalHome: [
                { routeName: "Festival Dates ", linkTo: "/Header-footer-date" },
                { routeName: "Content ", linkTo: "/home" },
                { routeName: "Email Template", linkTo: "/email-list" },
                { routeName: "Highlights", linkTo: "/highlights" }
            ],
            htfRouterInPerson: [
                { routeName: "Header", linkTo: "/fest-header-inPerson" },
                { routeName: "Tickets", linkTo: "/fest-tickets" },
                { routeName: "Getting Around", linkTo: "/fest-getting-around" },
                { routeName: "Venues", linkTo: "/venue" },
                { routeName: "Festival Stores", linkTo: "/festival-store" },
                { routeName: "Accessibility", linkTo: "/accessibility-inPerson" },
                { routeName: "COVID-19", linkTo: "/COVID-19" },
                { routeName: "Safety & Belonging", linkTo: "/safety-belonging-inPerson" },
                { routeName: "FAQ", linkTo: "/FAQ-inPerson" },
            ],
            htfRouterOnline: [
                { routeName: "Header", linkTo: "/fest-header-online" },
                { routeName: "Tickets", linkTo: "/tickets-redemptions" },
                { routeName: "How to Watch", linkTo: "/watch" },
                { routeName: "Check Your Tech", linkTo: "/check-your-tech" },
                { routeName: "Accessibility", linkTo: "/accessibility-online" },
                { routeName: "Safety & Belonging", linkTo: "/safety-belonging-online" },
                { routeName: "FAQ", linkTo: "/FAQ-online" },
            ],

            // PAF Start
            PostAcceptanceForm: [
                { routeName: "Projects", linkTo: "/paf-projectlist" },
            ],
            // Email Start
            emailTemplateList: [
                { routeName: "Email Template", linkTo: "/email-list" },
            ],
            // Waitlist Start
            waitlistList: [
                { routeName: "My Waitlists", linkTo: "/my-waitlists", cma: ADMIN_CMA_IDS.WAITLIST_MY_WAITLISTS },
                { routeName: "Waitlists", linkTo: "/waitlist-management", cma: ADMIN_CMA_IDS.WAITLIST_LIST },
            ],
            PafReferenceValues: [
                { routeName: "Credit Label", linkTo: "/project-film-credit-label" },
                { routeName: "Category", linkTo: "/project-film-category" },
            ],
            // PAF End
            locations: [
                { routeName: "Locations", linkTo: "/locations" },
                { routeName: "Landing Page", linkTo: "/Landing-Page" },
            ],
            referenceType: [
                { routeName: "Venue Type", linkTo: "/venue-type" },
                { routeName: "Location Accessibility", linkTo: "/location-accessibility" },
                { routeName: "Amenities", linkTo: "/amenities" },
            ],
            other: [
                { routeName: "Store Upsell Products", linkTo: "/store-listupsell-product" },
                { routeName: "Membership List", linkTo: "/member-list" },
                { routeName: "Fest Time Home", linkTo: "/fest-time-home" }
            ],
            accessControlledPages: [
                { routeName: "Access Controlled Pages", linkTo: "/access-controlled-pages" },
            ],
        };
    }

    changeRouter = (e) => {
        this.setState({ currPath: e })
    }

    getDisplayValue = (accNo, fallbackAccNo) => {
        const { profileName } = this.props;
        if (!profileName || !profileName.CMA) {
            return false;
        }
        let accessValue = profileName.CMA.find(_ => _.access == accNo);
        if (accessValue) {
            return accessValue.value;
        }
        return false;
    }

    // Child access wins when explicitly set in CMA; otherwise inherit the parent (same rule as the API)
    hasChildAccess = (childId, parentId) => {
        const { profileName } = this.props;
        const entry = profileName && profileName.CMA && profileName.CMA.find(_ => _.access == childId);
        return entry ? !!entry.value : !!this.getDisplayValue(parentId);
    }

    render() {
        const currPath = this.props.router.pathname === '/access-management' ? '/admin-dashboard' : this.props.router.pathname;
        const { profileName } = this.props

        let festivalHomePageList   = profileName && this.getDisplayValue(ADMIN_CMA_IDS.CONFIGURATION)
        let configFestivalDates    = profileName && this.getDisplayValue(ADMIN_CMA_IDS.CONFIG_FESTIVAL_DATES, ADMIN_CMA_IDS.CONFIGURATION)
        let configFestivalWebsite  = profileName && this.getDisplayValue(ADMIN_CMA_IDS.CONFIG_FESTIVAL_WEBSITE, ADMIN_CMA_IDS.CONFIGURATION)
        let configEmails           = profileName && this.getDisplayValue(ADMIN_CMA_IDS.CONFIG_EMAILS, ADMIN_CMA_IDS.CONFIGURATION)
        let configPageTakeover       = profileName && this.getDisplayValue(ADMIN_CMA_IDS.PAGE_TAKE_OVER, ADMIN_CMA_IDS.CONFIGURATION)
        let configArchivesPage = profileName && this.getDisplayValue(ADMIN_CMA_IDS.CONFIG_ARCHIVES_PAGE, ADMIN_CMA_IDS.CONFIGURATION)
        let FPGList = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FPG)
        let FPGCatalog           = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FPG_CATALOG, ADMIN_CMA_IDS.FPG)
        let FPGShortsProgram     = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FPG_SHORTS_PROGRAM, ADMIN_CMA_IDS.FPG)
        let FPGCategory          = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FPG_REFERENCE_CATEGORY, ADMIN_CMA_IDS.FPG)
        let FPGAwardCategory     = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FPG_REFERENCE_AWARD_CATEGORY, ADMIN_CMA_IDS.FPG)
        let FPGGenre             = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FPG_REFERENCE_GENRE, ADMIN_CMA_IDS.FPG)
        let FPGInterestTracks    = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FPG_REFERENCE_INTEREST_TRACKS, ADMIN_CMA_IDS.FPG)
        let FPGAccessibility     = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FPG_REFERENCE_ACCESSIBILITY, ADMIN_CMA_IDS.FPG)
        let FPGCreditLabel       = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FPG_REFERENCE_CREDIT_LABEL, ADMIN_CMA_IDS.FPG)
        let FPGDevices           = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FPG_REFERENCE_DEVICES, ADMIN_CMA_IDS.FPG)
        let FPGScreeningTypes    = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FPG_REFERENCE_SCREENING_TYPES, ADMIN_CMA_IDS.FPG)
        let ticketingList = profileName && this.getDisplayValue(ADMIN_CMA_IDS.TICKETING)
        let HTFList = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FEST)
        let screeningList = profileName && this.getDisplayValue(ADMIN_CMA_IDS.SCREENING)
        let productsCouponsList  = profileName && this.getDisplayValue(ADMIN_CMA_IDS.PRODUCT_COUPONS)
        let productAccess        = profileName && this.getDisplayValue(ADMIN_CMA_IDS.PRODUCT, ADMIN_CMA_IDS.PRODUCT_COUPONS)
        let couponsAccess        = profileName && this.getDisplayValue(ADMIN_CMA_IDS.COUPONS, ADMIN_CMA_IDS.PRODUCT_COUPONS)
        let storeUpsellAccess    = profileName && this.getDisplayValue(ADMIN_CMA_IDS.STORE_UPSELL, ADMIN_CMA_IDS.PRODUCT_COUPONS)
        let membershipListAccess = profileName && this.getDisplayValue(ADMIN_CMA_IDS.MEMBERSHIP_LIST, ADMIN_CMA_IDS.PRODUCT_COUPONS)
        // let aboutSundanceList = profileName && this.getDisplayValue(ADMIN_CMA_IDS.ABOUT_SUNDANCE)
        let festivalHelpList = profileName && this.getDisplayValue(ADMIN_CMA_IDS.FESTIVAL_HELP)
        let sponsorsList = profileName && this.getDisplayValue(ADMIN_CMA_IDS.SPONSORS)
        let privateScreningList = profileName && this.getDisplayValue(ADMIN_CMA_IDS.PRIVATE_SCREENING)
        let locationList = profileName && this.getDisplayValue(ADMIN_CMA_IDS.LOCATION)
        let locationListItem       = profileName && this.getDisplayValue(ADMIN_CMA_IDS.LOCATION_LIST, ADMIN_CMA_IDS.LOCATION)
        let locationLandingPage    = profileName && this.getDisplayValue(ADMIN_CMA_IDS.LOCATION_LANDING_PAGE, ADMIN_CMA_IDS.LOCATION)
        let locationVenueType      = profileName && this.getDisplayValue(ADMIN_CMA_IDS.LOCATION_REF_VENUE_TYPE, ADMIN_CMA_IDS.LOCATION)
        let locationAccessibility  = profileName && this.getDisplayValue(ADMIN_CMA_IDS.LOCATION_REF_ACCESSIBILITY, ADMIN_CMA_IDS.LOCATION)
        let locationAmenities      = profileName && this.getDisplayValue(ADMIN_CMA_IDS.LOCATION_REF_AMENITIES, ADMIN_CMA_IDS.LOCATION)
        let paf = profileName && this.getDisplayValue(ADMIN_CMA_IDS.POSTACCEPTANCEFORM)
        let email = profileName && this.getDisplayValue(ADMIN_CMA_IDS.EMAIL_TEMPLATES)
        let waitlist = profileName && this.getDisplayValue(ADMIN_CMA_IDS.WAITLIST)
        let headerFooter = profileName && this.getDisplayValue(ADMIN_CMA_IDS.HEADER_FOOTER)
        let adminHideShow = profileName && this.getDisplayValue(ADMIN_CMA_IDS.ALL_USER)
        let mobileAppNotification = profileName && this.getDisplayValue(ADMIN_CMA_IDS.MOBILE_PUSH_NOTIFICATION)
        let userActivitiesHideShow = profileName && this.getDisplayValue(ADMIN_CMA_IDS.USER_ACTIVITIES)
        let access_contolled_pages_list = profileName && this.getDisplayValue(ADMIN_CMA_IDS.ACCESS_CONTROLLED_PAGES)

        const otherDefault = ['/access-management', '/product-list', '/discounts-list', '/member-list', '/ticketing', '/admin-dashboard', '/home', '/highlights', '/filmlist', '/film',
            '/create-film', '/short-program-list', '/program-view', '/program', '/private-events-list', '/add-private-events',
            '/filmcategory', '/eventcategory', '/othereventscategory', '/newfrontiercategory', '/filmgenre', '/eventsgenre', '/filminterest', '/filmaccessibillity', '/eventsaccessiblity', '/othereventsaccessiblity', '/newfrontieraccessiblity',
            '/filmcreditlebel', '/new-frontier-creditlebel', '/fest-header-inPerson', '/fest-getting-around', '/venue', '/fest-tickets', '/festival-store', '/accessibility-inPerson', '/COVID-19', '/safety-belonging-inPerson', '/FAQ-inPerson', '/tickets-redemptions', '/watch', '/check-your-tech',
            '/fest-header-online', '/accessibility-online', '/health-wellness-online', '/safety-belonging-online', '/FAQ-online',
            '/screening', '/about-sundance', '/festival-help', '/add-sponsors'
        ]
        return (
            <div className="left_side_wrapper 123">
                <ProSidebar >
                    <Menu iconShape="square" active={true}>

                        {/* Users */}

                        {
                            adminHideShow
                                ? <SubMenu title="Users" style={{ display: adminHideShow ? 'block' : 'none' }}  >
                                    {
                                        userActivitiesHideShow ?
                                            this.state.usersActivityAll.map((item) => {
                                                return (
                                                    <MenuItem active={item.linkTo === currPath ? true : false}>
                                                        <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                                    </MenuItem>
                                                )
                                            }) :
                                            this.state.usersAdmin.map((item) => {
                                                return (
                                                    <MenuItem active={item.linkTo === currPath ? true : false}>
                                                        <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                                    </MenuItem>
                                                )
                                            })
                                    }
                                </SubMenu>
                                :
                                <SubMenu title="Users">
                                    {
                                        userActivitiesHideShow ?
                                            this.state.usersActivity.map((item) => {
                                                return (
                                                    <MenuItem active={item.linkTo === currPath ? true : false}>
                                                        <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                                    </MenuItem>
                                                )
                                            }) :
                                            this.state.users.map((item) => {
                                                return (
                                                    <MenuItem active={item.linkTo === currPath ? true : false}>
                                                        <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                                    </MenuItem>
                                                )
                                            })
                                    }
                                </SubMenu>
                        }

                        {/* Festival Program Guide */}
                        <SubMenu title="Festival Program Guide" className={profileName.fpgLocked ? "FPGdisable" : ''} style={{ display: FPGList ? 'block' : 'none' }}>
                            {<> {!profileName.fpgLocked && <>
                                <MenuItem active={"/filmlist" === currPath ? true : false} style={{ display: (FPGList && FPGCatalog) ? 'block' : 'none' }}>
                                    <Link onClick={this.changeRouter.bind(this, "/filmlist")} to="/filmlist">Catalog</Link>
                                </MenuItem>
                                <MenuItem active={"/short-program-list" === currPath ? true : false} style={{ display: (FPGList && FPGShortsProgram) ? 'block' : 'none' }}>
                                    <Link onClick={this.changeRouter.bind(this, "/short-program-list")} to="/short-program-list">Shorts Program</Link>
                                </MenuItem>

                                {(FPGList && (FPGCategory || FPGAwardCategory || FPGGenre || FPGInterestTracks || FPGAccessibility || FPGCreditLabel || FPGDevices || FPGScreeningTypes)) && (
                                <SubMenu title=" Reference Values">
                                    <MenuItem active={"/filmcategory" === currPath ? true : false} style={{ display: (FPGList && FPGCategory) ? 'block' : 'none' }}>
                                        <Link onClick={this.changeRouter.bind(this, "/filmcategory")} to="/filmcategory">Category</Link>
                                    </MenuItem>
                                    <MenuItem active={"/eventcategory" === currPath ? true : false} style={{ display: (FPGList && FPGAwardCategory) ? 'block' : 'none' }}>
                                        <Link onClick={this.changeRouter.bind(this, "/eventcategory")} to="/eventcategory">Award Category</Link>
                                    </MenuItem>
                                    <MenuItem active={"/filmgenre" === currPath ? true : false} style={{ display: (FPGList && FPGGenre) ? 'block' : 'none' }}>
                                        <Link onClick={this.changeRouter.bind(this, "/filmgenre")} to="/filmgenre">Genre & Type</Link>
                                    </MenuItem>
                                    <MenuItem active={"/filminterest" === currPath ? true : false} style={{ display: (FPGList && FPGInterestTracks) ? 'block' : 'none' }}>
                                        <Link onClick={this.changeRouter.bind(this, "/filminterest")} to="/filminterest">Interest Tracks</Link>
                                    </MenuItem>
                                    <MenuItem active={"/filmaccessibillity" === currPath ? true : false} style={{ display: (FPGList && FPGAccessibility) ? 'block' : 'none' }}>
                                        <Link onClick={this.changeRouter.bind(this, "/filmaccessibillity")} to="/filmaccessibillity">Accessibility</Link>
                                    </MenuItem>
                                    <MenuItem active={"/filmcreditlebel" === currPath ? true : false} style={{ display: (FPGList && FPGCreditLabel) ? 'block' : 'none' }}>
                                        <Link onClick={this.changeRouter.bind(this, "/filmcreditlebel")} to="/filmcreditlebel">Credit Label</Link>
                                    </MenuItem>
                                    <MenuItem active={"/screeningtype" === currPath ? true : false} style={{ display: (FPGList && FPGDevices) ? 'block' : 'none' }}>
                                        <Link onClick={this.changeRouter.bind(this, "/screeningtype")} to="/screeningtype">Devices</Link>
                                    </MenuItem>
                                    <MenuItem active={"/screeningtype" === currPath ? true : false} style={{ display: (FPGList && FPGScreeningTypes) ? 'block' : 'none' }}>
                                        <Link onClick={this.changeRouter.bind(this, "/screeningtype")} to="/screeningtype">Screening Types</Link>
                                    </MenuItem>
                                </SubMenu>)}</>}</>}
                        </SubMenu>

                        {/* Post-Acceptance Form */}
                        <SubMenu title="Post-Acceptance Form" style={{ display: paf ? 'block' : 'none' }}>
                            {
                                this.state.PostAcceptanceForm.map((item) => {
                                    return (
                                        <MenuItem active={item.linkTo === currPath ? true : false}>
                                            <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                        </MenuItem>
                                    )
                                })
                            }
                        </SubMenu>

                        {/* Ticketing */}
                        <MenuItem active={"/ticketing" === currPath ? true : false} style={{ display: ticketingList ? 'block' : 'none' }}>
                            <Link onClick={this.changeRouter.bind(this, "/ticketing")} to="/ticketing" >Ticketing</Link>
                        </MenuItem>

                        {/* Locations */}
                        <SubMenu title="Locations" style={{ display: locationList ? 'block' : 'none' }}>
                            <MenuItem active={"/locations" === currPath ? true : false} style={{ display: (locationList && locationListItem) ? 'block' : 'none' }}>
                                <Link onClick={this.changeRouter.bind(this, "/locations")} to="/locations">Locations</Link>
                            </MenuItem>
                            <MenuItem active={"/Landing-Page" === currPath ? true : false} style={{ display: (locationList && locationLandingPage) ? 'block' : 'none' }}>
                                <Link onClick={this.changeRouter.bind(this, "/Landing-Page")} to="/Landing-Page">Landing Page</Link>
                            </MenuItem>
                            {(locationList && (locationVenueType || locationAccessibility || locationAmenities)) && (
                            <SubMenu title="Reference Values">
                                <MenuItem active={"/venue-type" === currPath ? true : false} style={{ display: (locationList && locationVenueType) ? 'block' : 'none' }}>
                                    <Link onClick={this.changeRouter.bind(this, "/venue-type")} to="/venue-type">Venue Type</Link>
                                </MenuItem>
                                <MenuItem active={"/location-accessibility" === currPath ? true : false} style={{ display: (locationList && locationAccessibility) ? 'block' : 'none' }}>
                                    <Link onClick={this.changeRouter.bind(this, "/location-accessibility")} to="/location-accessibility">Location Accessibility</Link>
                                </MenuItem>
                                <MenuItem active={"/amenities" === currPath ? true : false} style={{ display: (locationList && locationAmenities) ? 'block' : 'none' }}>
                                    <Link onClick={this.changeRouter.bind(this, "/amenities")} to="/amenities">Amenities</Link>
                                </MenuItem>
                            </SubMenu>)}
                        </SubMenu>

                        {/* Products & Discounts */}
                        <SubMenu title="Products & Discounts" style={{ display: productsCouponsList ? 'block' : 'none' }}>
                            <MenuItem active={"/product-list" === currPath ? true : false} style={{ display: (productsCouponsList && productAccess) ? 'block' : 'none' }}>
                                <Link onClick={this.changeRouter.bind(this, "/product-list")} to="/product-list">Products</Link>
                            </MenuItem>
                            <MenuItem active={"/discounts-list" === currPath ? true : false} style={{ display: (productsCouponsList && couponsAccess) ? 'block' : 'none' }}>
                                <Link onClick={this.changeRouter.bind(this, "/discounts-list")} to="/discounts-list">Discounts</Link>
                            </MenuItem>
                        </SubMenu>

                        {/* Sponsors */}
                        <MenuItem active={'/add-sponsors' === currPath ? true : false} style={{ display: sponsorsList ? 'block' : 'none' }}>
                            <Link onClick={this.changeRouter.bind(this, '/add-sponsors')} to='/add-sponsors' >Sponsors</Link>
                        </MenuItem>

                        {/* Waitlist Management */}
                        <SubMenu title="Waitlist Management" defaultOpen={['/my-waitlists', '/waitlist-management', '/waitlist-detail'].includes(currPath) ? true : false} style={{ display: waitlist ? 'block' : 'none' }}>
                            {
                                this?.state?.waitlistList?.map((item) => {
                                    return (
                                        <MenuItem key={item.linkTo} active={item.linkTo === currPath ? true : false} style={{ display: this.hasChildAccess(item.cma, ADMIN_CMA_IDS.WAITLIST) ? "block" : "none" }}>
                                            <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo} >{item.routeName}</Link>
                                        </MenuItem>
                                    )
                                })
                            }
                        </SubMenu>

                        {/* Configuration */}
                        <SubMenu title="Configuration" style={{ display: festivalHomePageList ? 'block' : 'none' }}>
                            <MenuItem active={"/Header-footer-date" === currPath ? true : false} style={{ display: (festivalHomePageList && configFestivalDates) ? 'block' : 'none' }}>
                                <Link onClick={this.changeRouter.bind(this, "/Header-footer-date")} to="/Header-footer-date">Festival Dates </Link>
                            </MenuItem>
                            <MenuItem active={"/home" === currPath ? true : false} style={{ display: (festivalHomePageList && configFestivalWebsite) ? 'block' : 'none' }}>
                                <Link onClick={this.changeRouter.bind(this, "/home")} to="/home">Festival Website </Link>
                            </MenuItem>
                            <MenuItem active={"/email-list" === currPath ? true : false} style={{ display: (festivalHomePageList && configEmails) ? 'block' : 'none' }}>
                                <Link onClick={this.changeRouter.bind(this, "/email-list")} to="/email-list">Email Template</Link>
                            </MenuItem>
                            <MenuItem active={"/page-takeover-list" === currPath ? true : false} style={{ display: (festivalHomePageList && configPageTakeover) ? 'block' : 'none' }}>
                                <Link onClick={this.changeRouter.bind(this, "/page-takeover-list")} to="/page-takeover-list">Page Takeover</Link>
                            </MenuItem>
                            <MenuItem active={"/archives-page" === currPath ? true : false} style={{ display: (festivalHomePageList && configArchivesPage) ? 'block' : 'none' }}>
                                <Link onClick={this.changeRouter.bind(this, "/archives-page")} to="/archives-page">Archives Page</Link>
                            </MenuItem>
                        </SubMenu>
                        {/* Access Controlled Pages */}
                        <SubMenu title="Access Controlled Pages" style={{ display: access_contolled_pages_list ? 'block' : 'none' }}>
                            {this.state.accessControlledPages.map((item) => (
                                <MenuItem active={item.linkTo === currPath} key={item.linkTo}>
                                    <Link onClick={this.changeRouter.bind(this, item.linkTo)} to={item.linkTo}>
                                        {item.routeName}
                                    </Link>
                                </MenuItem>
                            ))}
                        </SubMenu>
                    </Menu>
                </ProSidebar>
            </div>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SioAndPressSidebar);